import { ClientContractor } from '@numeo/types-core'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ViewType } from 'pages/dashboard/pages/updater-agent/pages/ongoing-loads/types'
import { RootState } from 'store'

interface ContractorState {
    currentView: ViewType
    selectedContractor: ClientContractor | null
    isLoading: boolean
    searchTerm: string
    selectedContractorIds: string[]
    deleteConfirmOpen: boolean
    contractorToDelete: ClientContractor | null
    truckAssignModalOpen: boolean
    editInitialStep: number | null
}

const initialState: ContractorState = {
    currentView: 'list',
    selectedContractor: null,
    isLoading: false,
    searchTerm: '',
    selectedContractorIds: [],
    deleteConfirmOpen: false,
    contractorToDelete: null,
    truckAssignModalOpen: false,
    editInitialStep: null,
}

const contractorSlice = createSlice({
    name: 'contractor',
    initialState,
    reducers: {
        setCurrentView(state, action: PayloadAction<ViewType>) {
            state.currentView = action.payload
        },
        setSelectedContractor(state, action: PayloadAction<ClientContractor | null>) {
            state.selectedContractor = action.payload
        },
        setIsLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload
        },
        setSearchTerm(state, action: PayloadAction<string>) {
            state.searchTerm = action.payload
        },
        setSelectedContractorIds(state, action: PayloadAction<string[]>) {
            state.selectedContractorIds = action.payload
        },
        setDeleteConfirmOpen(state, action: PayloadAction<boolean>) {
            state.deleteConfirmOpen = action.payload
        },
        setContractorToDelete(state, action: PayloadAction<ClientContractor | null>) {
            state.contractorToDelete = action.payload
        },
        setTruckAssignModalOpen(state, action: PayloadAction<boolean>) {
            state.truckAssignModalOpen = action.payload
        },
        setEditInitialStep(state, action: PayloadAction<number | null>) {
            state.editInitialStep = action.payload
        },
    },
})

export const {
    setCurrentView,
    setSelectedContractor,
    setIsLoading,
    setSearchTerm,
    setSelectedContractorIds,
    setDeleteConfirmOpen,
    setContractorToDelete,
    setTruckAssignModalOpen,
    setEditInitialStep,
} = contractorSlice.actions

export const selectContractorState = (state: RootState) => state.contractor
export type { ContractorState }
export default contractorSlice.reducer
